import React from "react"

export const Products = () => ({
  commands: {
    insertProduct: (editor, { text }) => {
      editor
        .moveToEndOfBlock()
        .insertBlock({ type: "product", data: {} })
        .insertText(text)
    }
  },
  renderNode(props, editor, next) {
    const { children, node, attributes } = props
    switch (node.type) {
      case "product":
        return (
          <div {...attributes}>
            <link rel="stylesheet" href="https://demo.ck.page/commerce.css" />
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className="convertkit-button"
              style={{
                display: "inline-block",

                textDecoration: "none"
              }}
            >
              {children}
            </a>
          </div>
        )

      default:
        return next()
    }
  }
})
